import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Breadcrumb,
  Card,
  Col,
  Container,
  Row,
} from "react-bootstrap";

import {
  CustomPaging,
  EditingState,
  PagingState,
  SortingState,
} from '@devexpress/dx-react-grid';

import {
  Grid,
  PagingPanel,
  Table,
  TableHeaderRow,
  TableEditColumn,
  SearchPanel,
  Toolbar,
} from '@devexpress/dx-react-grid-bootstrap4';

import PopupEditing from 'components/ReactTable/PopupEditing.js';
import { useAlert, TYPES } from 'hooks/use-alert-hook.js';
import Popup from './Popup.js';
import { SearchState } from '@devexpress/dx-react-grid';
import { Loading } from 'components/Loading/loading';

const SORT_FIELD_MAP = {};

export default function Index() {

  const [swal, setSwal] = useAlert();
  const [columns] = useState([
    { name: 'SCORE_ID', title: 'ID' },
    { name: 'SCORE_NAME', title: 'Score Name' },
    { name: 'SCORE_CALCULATE', title: 'Calculate', getCellValue: row => (row.SCORE_CALCULATE === 1) ? 'YES' : 'NO' },
    { name: 'SCORE_STATUS', title: 'Status' },
  ]);
  const [rows, setRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [pageSizes] = useState([5, 10, 15]);
  const [searchValue, setSearchValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [sorting, setSorting] = useState([{ columnName: 'SCORE_ID', direction: 'asc' }]);

  const commitChanges = async ({ added, changed, deleted }) => {

    try {
      if (added) {
        const newItem = {...added.pop()};

        const response = await axios.post(`${process.env.REACT_APP_API_HOST}scores`, newItem);
        if (response.status !== 201) {
          throw new Error(`Create new error`);
        }

        setSwal({
          type: TYPES.SUCCESS,
          payload: {
            title: `Score successfuly added`,
            message: ``,
          }
        });

        return fetchData(),  [searchValue, pageSize, currentPage];
      }

      if (changed) {
        const id = Object.keys(changed).pop();
        const updatedItem = { ...changed[id] };

        const response = await axios.put(`${process.env.REACT_APP_API_HOST}scores/${id}`, updatedItem);
        if (response.status !== 200) {
          throw new Error(`Update data error`);
        }

        setSwal({
          type: TYPES.SUCCESS,
          payload: {
            title: `Score successfuly updated`,
            message: ``,
          }
        });

        return fetchData();
      }

      if (deleted) {
        const item = rows.find(row => row.SCORE_ID === [...deleted].pop());
        const onSuccessCallback = async () => {
          const response = await axios.delete(`${process.env.REACT_APP_API_HOST}scores/${item.SCORE_ID}`);
          if (response.status !== 204) throw new Error('Delete error');
          return fetchData();
        }

        setSwal({
          type: TYPES.CONFIRM,
          payload: {
            title: `Are you sure`,
            message: `You are about to delete "${item.SCORE_NAME}" scope.`,
            onSuccess: {
              title: `Success`,
              message: `Delete Success`,
              callback: onSuccessCallback,
            }
          }
        });
      }

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
     }

  };

  const getRowId = row => row.SCORE_ID;

  const fetchData = async () => {

    setLoading(true);

    try {

      const orderBy = sorting?.[0];
      const response = await axios.get(`${process.env.REACT_APP_API_HOST}scores`, {
        params: {
          page: currentPage + 1,
          'per-page': pageSize,
          'search': searchValue,
          sort: `${orderBy?.direction === 'desc' ? '-' : ''}${SORT_FIELD_MAP[orderBy?.columnName] ?? orderBy?.columnName}`
        }
      });

      if (response.status !== 200) throw new Error(`Fetch error`);

      setRows(response.data.items);
      setTotalCount(response.data._meta.totalCount);

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }

    setLoading(false);
  }

  useEffect(fetchData, [searchValue, pageSize, currentPage, sorting]);

  return (
    <>
      {swal}
      <Container fluid>
        <Breadcrumb>
          <Breadcrumb.Item href="#pablo" onClick={(e) => e.preventDefault()}>
            Master
          </Breadcrumb.Item>
          <Breadcrumb.Item href="#pablo" onClick={(e) => e.preventDefault()}>
            Auditor
          </Breadcrumb.Item>
          <Breadcrumb.Item aria-current="page" active>
            Index
          </Breadcrumb.Item>
        </Breadcrumb>

        {rows && (
          <Row>
            <Col md="12">
              <Card>
                <Card.Header>
                  <Card.Title as="h4">Score List</Card.Title>
                </Card.Header>
                <Card.Body>
                  <Grid
                    rows={rows}
                    columns={columns}
                    getRowId={getRowId}
                  >
                    <SearchState onValueChange={setSearchValue} />

                    <SortingState
                      sorting={sorting}
                      onSortingChange={setSorting}
                    />

                    <PagingState
                      currentPage={currentPage}
                      onCurrentPageChange={setCurrentPage}
                      pageSize={pageSize}
                      onPageSizeChange={setPageSize}
                    />
                    <CustomPaging totalCount={totalCount} />
                    <EditingState
                      onCommitChanges={commitChanges}
                    />
                    <Table />
                    <TableHeaderRow showSortingControls />
                    <TableEditColumn
                      showAddCommand
                      showEditCommand
                      showDeleteCommand
                    />
                    <PopupEditing popupComponent={Popup} />

                    <PagingPanel
                      pageSizes={pageSizes}
                    />
                    <Toolbar />
                    <SearchPanel />
                    {loading && <Loading />}
                  </Grid>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        )}
      </Container>
    </>
  )
}

